import {Routes} from '@angular/router';
import {UserProfileComponent} from './user-profile/user-profile.component';

export const userRoutesProtected: Routes = [{path: 'settings', component: UserProfileComponent}];
